module.exports = __webpack_public_path__ + "fonts/raleway-v12-latin-500.eot";